export default function handleSquareVisibility(
  isVisibleOnMobile,
  isHidden,
  styles
) {
  if (!isVisibleOnMobile) return styles._hidden_on_mobile;
  else if (isHidden) return styles._hidden;
  else return "";
}
